import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CopyRight from './CopyRight';
import GetACallBackModal from 'Pages/Home/Components/GetACallBackModal';
import UploadPrescriptionModal from 'Components/CommonComponents/Modal/UploadPrescriptionModal';
import GetHelpModal from 'Components/CommonComponents/Modal/HelpModal';
import AddAddressModal from 'Pages/Home/Components/AddAddressModal';
import WhiteLogo from 'Assets/images/whitelogo.png';
import { slugify } from 'Utils/Functions';
import axiosInstance from 'Utils/Interceptor';
import ourGroup from '../../../src/Assets/pdf/our_group.pdf';

const Footer = () => {
  const homeData = useSelector((e) => e?.states.homePageData);
  const [showLabModal, setShowLabModal] = useState(false);
  const [footerData, setFooterData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  let { cityName } = useSelector((state) => state.location);
  cityName = slugify(cityName);
  const [selectedCategories, setSelectedCategories] = useState({
    label: cityName || 'Default City',
    value: cityName || 'Default City'
  });

  const handleLabModal = () => setShowLabModal(!showLabModal);

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const response = await axiosInstance.get('/api/user/footer');
        setFooterData(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching footer data:', error);
        setIsLoading(false);
      }
    };

    fetchFooterData();
  }, []);

  if (isLoading) {
    return <div>Loading footer...</div>;
  }

  return (
    <footer className="footer">
      <div className="pre-footer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="pre-footer-wrapper">
                <div className="pre-footer-content">
                  <h2>Popular Pathology Test</h2>
                  <div
                    className="pre-footer-content-listing"
                    dangerouslySetInnerHTML={{
                      __html: footerData?.popular_pathology_test || ''
                    }}
                  />
                </div>

                {/* <div className="pre-footer-content">
                  <h2>Popular Pathology Test Categories</h2>
                  <div
                    className="pre-footer-content-listing"
                    dangerouslySetInnerHTML={{
                      __html: footerData?.popular_pathology_test_category || ''
                    }}
                  />
                </div> */}

                {/* <div className="pre-footer-content">
                  <h2>Popular Pathology Test Locations</h2>
                  <div
                    className="pre-footer-content-listing"
                    dangerouslySetInnerHTML={{
                      __html: footerData?.popular_pathology_test_location || ''
                    }}
                  />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="footer-wrapper">
                <div className="footer-item">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to={`/${cityName}/health-packages`}>
                        Health Packages
                      </Link>
                    </li>
                    <li>
                      <Link to={`/${cityName}/blood-tests`}>Blood Tests</Link>
                    </li>
                    <li>
                      <Link to={`/testing-specialty`}>Testing Specialty</Link>
                    </li>
                    <li>
                      <Link to={`/${cityName}/unifit-weekend-wellness`}>
                        Unifit Weekend Wellness
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="footer-item">
                  <ul>
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/why-unipath">Why Unipath</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blogs</Link>
                    </li>
                    <li>
                      <Link to="/knowledge-sharing">Knowledge Sharing</Link>
                    </li>
                    <li>
                      <Link to="/frequently-asked-questions">FAQ</Link>
                    </li>
                    <li>
                      <Link to="/offers">Offers</Link>
                    </li>
                  </ul>
                </div>

                <div className="footer-item">
                  <div className="footer-heading-links">Quick Links</div>
                  <ul>
                    <li>
                      <Link
                        to="/my-reports"
                        state={{ from: 'Home' }}
                      >
                        Download Report
                      </Link>
                    </li>
                    <li>
                      <UploadPrescriptionModal>
                        <span>Upload Prescription</span>
                      </UploadPrescriptionModal>
                    </li>
                    <li>
                      {/* <Link to={'/locatelab/ahmedabad'}>Locate A Lab</Link> */}
                      <Link
                        to={`/locatelab/${selectedCategories?.value
                          .toLowerCase()
                          .replace(/ /g, '-')}`}
                      >
                        Locate A Lab
                      </Link>
                    </li>
                    <li>
                      <GetACallBackModal>
                        <span>Get A Call Back</span>
                      </GetACallBackModal>
                    </li>
                    <li>
                      <GetHelpModal>
                        <span>Help and Feedback</span>
                      </GetHelpModal>
                    </li>
                    <li>
                      <Link to="/reach-us">Reach Us</Link>
                    </li>
                    {/* <li>
                      <Link to="/career">Careers</Link>
                    </li> */}
                    <li>
                      <a
                        href="https://unipath.texlaculture.ai/careers"
                        target="_blank"
                        rel=""
                      >
                        Careers
                      </a>
                    </li>

                    <li>
                      <Link to="/investment-info">Investor Information</Link>
                    </li>
                    <li>
                      <a
                        href={ourGroup}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Our Group Companies
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="footer-item">
                  <div className="footer-heading-links">Contact Us</div>
                  <ul>
                    <li>
                      <a href="tel:+917949006800">
                        Phone: +91 (079) 4900 6800/
                      </a>
                      <a href="tel:+916356355500"> +916356355500</a>
                    </li>
                    <li>
                      <a
                        href="https://wa.me/917623009800"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        WhatsApp: +91 7623009800
                      </a>
                    </li>
                    <li>
                      <a href="mailto:info@unipath.in">
                        Email: info@unipath.in
                      </a>
                    </li>
                  </ul>

                  <div className="social-links">
                    <ul>
                      {homeData?.socialmedia?.map((item) => (
                        <li key={item.socialmedia_id}>
                          <Link
                            to={item.url}
                            target="_blank"
                          >
                            <img
                              src={item.icon}
                              alt={item.icon}
                            />
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="footer-logo-wrapper">
                    <figure className="footer-logo">
                      <img
                        src={WhiteLogo}
                        alt="galleryImage"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CopyRight />

      <div className="pre-booking-footer">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12">
              <p>
                © 2025, Unipath Specialty Laboratory Ltd. All rights reserved
              </p>
            </div>
          </div>
        </div>
      </div>

      {showLabModal && (
        <AddAddressModal
          show={showLabModal}
          handleCloseModal={handleLabModal}
        />
      )}
    </footer>
  );
};

export default Footer;
